<div class="row text-center">
  <div class="col">
    <div class="header-icon full-icon">
      <figure>
        <img src="./assets/img/images/expired.svg" alt="Otp" />
      </figure>
    </div>
    <h1 class="title-copy">{{ "Need personal assistance" | translate }}</h1>
    <div class="para brand-lite-blue sub-title-copy text-center margin-bottom mb16">
      {{ "REVIEW_AND_UPDATE" | translate }}
    </div>
    <div class="row margin-bottom mb24">
      <div class="col">
        <div class="policy-info-content dm-sans-medium font-medium">
          <ul class="txt-center">
            <li>
              <strong>{{ policyHolderName }}</strong>
            </li>
            <li>
              {{ "DATA_OF_BIRTH" | translate }}:&nbsp;<strong>{{
                dateOfBirth | date:'MM/dd/yyyy'
                }}</strong>
            </li>
            <li>
              {{ "ZIP_CODE" | translate }}:&nbsp;<strong>{{ zipCode }}</strong>
            </li>
            <li>
              {{ "POLICY" | translate }}:&nbsp;<strong>{{
                policyNumber
                }}</strong>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div></div>
    <div class="row">
      <div class="col text-center">
        <p class="brand-lite-blue">{{ "MAX_ATTEMPTS" | translate }}</p>
        <ng-container *ngIf="isAcmic; else MAstate">
          <p class="x-att-contact">
            <a href="mailto:eccservicecenter&#64;Insure.WA.AAA.com">
              eccservicecenter&#64;Insure.WA.AAA.com
            </a>
          </p>
        </ng-container>
        <ng-template #MAstate>
        </ng-template>
        <p class="x-att-contact">
          <a href="tel:{{ 'CUSTOMER_SERVICE_NUMBER' | translate }}" class="mapfre link blue-link underline"
            [ngClass]="{ 'corporate-red font-size-16 dm-sans-medium': !isAcmic , 'underline': isAcmic}">
            {{ "CUSTOMER_SERVICE_NUMBER" | translate }}
          </a>
        </p>
      </div>
    </div>
    <div *ngIf="showMessageApp" class="grey-color app-font-size">
      {{ 'MA_ONLY_APP_NOTIFICATION' | translate }}
    </div>
  </div>
</div>